module.exports = __webpack_public_path__ + "img/bannericon1.407be857.png";